export enum FolioTypeEndPoint {
    PREVENTIVE = "preventive",
    CORRECTIVE = "corrective",
}